import type { BugsnagErrorBoundary } from '@bugsnag/plugin-react';

import { getErrorBoundary } from './bugsnag';
// only handle react render function error
export const WithErrorBoundary: BugsnagErrorBoundary = ({
  children,
  FallbackComponent,
  onError,
}) => {
  const ErrorBoundary = getErrorBoundary();

  if (ErrorBoundary) {
    return (
      <ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
        {children}
      </ErrorBoundary>
    );
  }

  return <>{children}</>;
};
